var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.card && _vm.card.info && (_vm.card.info.total_evaluations_visibility || _vm.card.user_id !== _vm.user.id))?_c('div',[_vm._v(" "+_vm._s(_vm.scope.row.scale.fact)+" ")]):_c('div',{staticStyle:{"color":"#b1b1b2"}},[_vm._v(" Скрыто ")])}
var staticRenderFns = []

export { render, staticRenderFns }